import BlobImage from "../../components/BlobImage/BlobImage";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./GroupCockpitDashboard.module.css";
import { AxiosInstance, TokenService } from "../../services/Api";
import schoolImage from "../../assets/images/school.png";

const GroupCockpitDashboard = () => {
  const navigate = useNavigate();
  const user = TokenService.getUser();
  const userId = user?.id || 0;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [schoolCards, setSchoolCards] = useState([]);
  const [clientId, setClientId] = useState("");

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get(
        `/groupCockpit/Dashboard/${userId}`,
      );

      if (response.data?.success) {
        const data = response.data.data[0];
        setError(null);
        setClientId(data.id || "");
        const numberOfSchools = data.no_of_schools || 0;
        const existingSchools = data.schools || [];
        const cards = [];

        for (let i = 0; i < numberOfSchools; i++) {
          if (existingSchools[i]) {
            // If school exists at this index, store all school data
            cards.push({
              id: existingSchools[i].id,
              school_logo: existingSchools[i].school_logo,
              name:
                existingSchools[i].short_school_name ||
                existingSchools[i].school_name ||
                existingSchools[i].name,
              shortSchoolName: existingSchools[i].short_school_name,
              clientId: existingSchools[i].client_id,
              userId: existingSchools[i].user_id,
              isExisting: true,
            });
          } else {
            // If no school at this index, show "Add New School"
            cards.push({
              id: null,
              name: "Add New School",
              shortSchoolName: null,
              clientId: null,
              userId: null,
              isExisting: false,
            });
          }
        }

        setSchoolCards(cards);
      } else {
        throw new Error(
          response.data?.message || "Failed to fetch dashboard data",
        );
      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError(err.message || "Failed to load dashboard data");
    } finally {
      setLoading(false);
    }
  };

  const handleAddSchool = () => {
    navigate("/user/school-setup", {
      state: { CLIENTID: clientId },
    });
  };

  const handleSearchClick = (school) => {
    navigate(`/user/school-setup/${school.id}`, {
      state: { CLIENTID: clientId },
    });
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingWrapper}>
          <div className={styles.spinner}></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.errorWrapper}>
          <i className="fa-solid fa-circle-exclamation"></i>
          <p>{error}</p>
          <button onClick={fetchDashboardData} className={styles.retryButton}>
            <i className="fa-solid fa-rotate-right"></i> Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.cardsWrapper}>
        {schoolCards.map((school) => (
          <div
            key={school.id}
            className={`${styles.schoolCard} ${
              !school.isExisting ? styles.addNewCard : ""
            }`}
            // onClick={() =>
            //   school.isExisting ? handleSchoolClick(school) : handleAddSchool()
            // }
          >
            <div className={styles.imageWrapper}>
              <BlobImage
                path={school.school_logo}
                fallback={schoolImage}
                alt={school.name}
                className={styles.schoolImage}
              />
            </div>
            <div className={styles.cardContent}>
              {school.isExisting ? (
                <button
                  className={styles.searchButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSearchClick(school);
                  }}
                  title="Search"
                >
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
              ) : (
                <button
                  className={styles.addButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddSchool();
                  }}
                  title="Add New School"
                >
                  <i className="fa-solid fa-plus"></i>
                </button>
              )}
              <h3 className={styles.schoolName}>{school.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GroupCockpitDashboard;
